import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { connect } from 'react-redux';

import CommentsList from './CommentList';
import AuthorMessage from '../components/AuthorMessage';
import SidebarProfile from '../components/SidebarProfile';
import { LandingPageType } from '~/types/redux/share';
import useLanguage from '~/i18n';
import ReplyPanelContainer from './ReplyPanelContainer';

@connect((state) => {
  return {
    greet: state.root.model,
    assignee: state.root.assignee,
    comments: state.comments.comments,
    isRecipient: state.root.isRecipient,
    messageTemplate: state.root.messageTemplate,
  };
})
class Sidebar extends Component {
  componentDidUpdate(prevProps: Component) {
    if (this.props.comments.length > prevProps.comments.length) {
      this.commentList.scrollTop = this.commentList.scrollHeight;
    }
  }

  render() {
    const { assignee, greet, comments, messageTemplate, isRecipient } =
      this.props;
    useLanguage(assignee.locale);

    return (
      <div className='box-sidebar'>
        <SidebarProfile {...assignee} />

        <div className='sidebar-messages' ref={(r) => (this.commentList = r)}>
          <AuthorMessage
            model={greet}
            assignee={assignee}
            messageTemplate={messageTemplate}
            landingPageType={LandingPageType.Greet}
          />

          {isRecipient && (
            <CommentsList
              comments={comments}
              viewedByRecipient
              recipientName={assignee.first_name ?? ''}
            />
          )}
        </div>

        {isRecipient && (
          <div className='flex-1'>
            <ReplyPanelContainer />
          </div>
        )}
      </div>
    );
  }
}

Sidebar.propTypes = {
  comments: PropTypes.array.isRequired,
  assignee: PropTypes.object.isRequired,
  greet: PropTypes.object.isRequired,
  messageTemplate: PropTypes.object.isRequired,
  isRecipient: PropTypes.bool,
};

export default Sidebar;
